import PropTypes from 'prop-types';
import React from 'react';

import {Collaborator, Ownable, Owner, OwnerInfo, HasOwnablePermissions} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import OwnableSettingsModal from 'create-components/OwnableSettingsModal';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import {InputChangeEvent} from 'util/Types';
import {WorkflowTemplate} from 'workflows/WorkflowConstants';

interface WorkflowTemplateBaseSettingsModalProps {
  existingOwnable?: Ownable & Pick<HasOwnablePermissions, 'permissions'>;
  ownableId?: string;
  onRequestClose: () => void;
  doDelete?: () => void;
  doSubmit: (data: Ownable) => JQueryPromise<{workflowTemplate: WorkflowTemplate}>;
  title?: string;
}

interface State {
  prefix: string;
}

class WorkflowTemplateBaseSettingsModal extends React.Component<
  WorkflowTemplateBaseSettingsModalProps,
  State
> {
  static propTypes = {
    existingOwnable: PropTypes.object,
    ownableId: PropTypes.string,
    onRequestClose: PropTypes.func.isRequired,
    doDelete: PropTypes.func,
    doSubmit: PropTypes.func.isRequired,
    title: PropTypes.string,
  };

  override state: State = {prefix: this.props.existingOwnable ? this.props.existingOwnable.prefix : 'PD'};

  _handleChangePrefix = (e: InputChangeEvent): void => {
    this.setState({prefix: e.target.value});
  };

  _handleSubmit = (data: {
    name: string;
    owner: Owner;
    ownerInfo: OwnerInfo;
    collaborators: Array<Collaborator>;
  }): JQueryPromise<{workflowTemplate: WorkflowTemplate}> =>
    this.props.doSubmit({...data, prefix: this.state.prefix});

  _isValidInput(): boolean {
    return this.state.prefix.length > 0;
  }

  _isReadOnly(): boolean {
    if (!this.props.existingOwnable) {
      return false; // creation flow
    }
    return !this.props.existingOwnable.permissions.admin;
  }

  override render(): JSX.Element {
    return (
      <OwnableSettingsModal
        title={this.props.title}
        ownableType={ModelTypeConstants.WORKFLOW_TEMPLATE}
        ownableId={this.props.ownableId}
        existingOwnable={this.props.existingOwnable}
        onRequestClose={this.props.onRequestClose}
        doSubmit={this._handleSubmit}
        doDelete={this.props.doDelete}
        enableDescription={false}
        disableSave={!this._isValidInput()}
        isReadOnly={this._isReadOnly()}
        // eslint-disable-next-line react/no-unstable-nested-components -- Disabling for now, but worth fixing
        customSettingsComponent={() => (
          <Row>
            <Col sm={12}>
              <FormGroup>
                <Label className="required">Workflow ID prefix</Label>
                <FormInput
                  name="prefix"
                  type="text"
                  value={this.state.prefix}
                  onChange={this._handleChangePrefix}
                  readOnly={this._isReadOnly()}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
      />
    );
  }
}

export default WorkflowTemplateBaseSettingsModal;
